export default function () {
  const menuButtons = document.querySelectorAll('.navigation-menu-button');

  if (menuButtons.length === 0) return;
  let isActive = false;
  const menu = document.querySelector('#menu');
  const menuItems = document.querySelector('#menu-items');
  const navElements = document.querySelectorAll('.nav');
  const modalSignupInMenu = document.querySelector('#modalSignupInMenu');

  if (modalSignupInMenu) {
    modalSignupInMenu.addEventListener('click', function() {
      setTimeout(close, 200);
    });
  }

  function open () {
    [].forEach.call(menuButtons, menuButton => {
      menuButton.classList.add('-active');
    });
    menu.classList.add('-active');
    isActive = true;
    [].forEach.call(navElements, navElement => {
      navElement.classList.add('-opened');

      const navElementViewportOffset = navElement.getBoundingClientRect().top;

      if (navElementViewportOffset) {
        navElement.style.transform = `translateY(-${navElementViewportOffset}px)`;
      }
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function close () {
    [].forEach.call(navElements, navElement => {
      navElement.style.transform = 'initial';
      navElement.classList.remove('-opened');
    });
    [].forEach.call(menuButtons, menuButton => {
      menuButton.classList.remove('-active');
    });
    menu.classList.remove('-active');
    isActive = false;
    document.documentElement.style.overflow = 'auto';
  }

  menu.addEventListener('click', function (event) {
    if (menu.contains(menuItems) && event.target === menu) {
      close();
    }
  });

  [].forEach.call(menuButtons, menuButton => {
    menuButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (isActive) {
        close();
      } else {
        open();
      }
    });
  });

  document.addEventListener('keyup', function (e) {
    if (e.keyCode === 27) {
      close();
    }
  });
}